import React, { useState } from 'react';

// MUI Components
import Dialog from '@mui/material/Dialog';
import DialogTitle from '@mui/material/DialogTitle';
import DialogContent from '@mui/material/DialogContent';
import DialogActions from '@mui/material/DialogActions';
import Button from '@mui/material/Button';
import ButtonGroup from '@mui/material/ButtonGroup';
import Box from '@mui/material/Box';

// Components
import AlertForm from './alert-form';
import EmailForm from './email-form';
 
const AlertModal = ({ open, setOpen, selectedSites = [], existingAlert = null, existingEmail = null, allSites = false }) => {

    const [alertType, setAlertType]             = useState('notification');
    const [content, setContent]                 = useState('');
    const [schedule, setSchedule]               = useState(true);

    const handleClose = () => {
        setOpen(false);
    }

    const modalTitle = existingEmail ? 'Edit Email' : existingAlert ? 'Edit Alert' : 'Create Alert';

    return (
        <Dialog open={open} onClose={handleClose} maxWidth='md' fullWidth className='alert-modal'>
            <DialogTitle className='error-logs-modal-title'>{modalTitle}</DialogTitle>
            <DialogContent>
                <Box className='alert-form'>
                    {allSites ? (
                        <p className='alert-form-selected-sites'>This notice will apply to all sites</p>
                    ) : selectedSites.length > 0 && (
                        <p className='alert-form-selected-sites'>{selectedSites.length} client{selectedSites.length > 1 ? 's' : ''} selected</p>
                    )}
                    {( null === existingAlert && null === existingEmail ) && (
                        <>
                            {!allSites && (
                                <ButtonGroup>
                                    <Button onClick={() => setAlertType('notification')} variant={alertType === 'notification' ? 'contained' : 'outlined'}>Site Notification</Button>
                                    <Button onClick={() => setAlertType('email')} variant={alertType === 'email' ? 'contained' : 'outlined'}>Client Email</Button>
                                </ButtonGroup>
                            )}
                            <Box style={{ display: allSites || alertType === 'notification' ? 'block' : 'none' }}>
                                <AlertForm
                                    selectedSites={selectedSites}
                                    allSites={allSites}
                                    handleClose={handleClose}
                                    content={content}
                                    setContent={setContent}
                                    schedule={schedule}
                                    setSchedule={setSchedule}
                                />
                            </Box>
                            <Box style={{ display: !allSites && alertType === 'email' ? 'block' : 'none' }}>
                                <EmailForm
                                    selectedSites={selectedSites}
                                    handleClose={handleClose}
                                    content={content}
                                    setContent={setContent}
                                    schedule={schedule}
                                    setSchedule={setSchedule}
                                />
                            </Box>
                        </>
                    )}
                    {existingAlert && (
                        <AlertForm selectedSites={selectedSites} handleClose={handleClose} existingAlert={existingAlert} />
                    )}
                    {existingEmail && (
                        <EmailForm key={existingEmail.id} selectedSites={selectedSites} handleClose={handleClose} existingEmail={existingEmail} />
                    )}
                </Box>
            </DialogContent>
            <DialogActions>
                <Button variant='contained' color='error' onClick={handleClose}>Close</Button>
            </DialogActions>
        </Dialog>
    )

}

export default AlertModal;
